var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tile-selector',{attrs:{"id":("tile-selector_question-" + (_vm.question.number) + "-device"),"question":_vm.updatedQuestion,"value":_vm.value,"readonly":_vm.readonly},on:{"input":_vm.handleSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }